<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Licences</p>
      </div>
      <div class="m-2">
        <licence-tabs
          :updateLicenceList="updateLicenceList"
          v-if="searchInput"
        ></licence-tabs>
        <licence-tabs
          :updateLicenceList="updateLicenceList"
          v-if="!searchInput.length"
        ></licence-tabs>
      </div>

      <div class="flex justify-between mt-0">
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="p-2 bg-gray-200 w-52 m-2 mb-0 py-1 rounded-md"
        />
        <!-- search -->
        <div class="flex gap-3">
          <div
            @click="upgradeKey"
            class="bg-primary flex text-white items-center text-sm px-3 cursor-pointer gap-2 py-1 rounded-md m-2 mb-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m22 0h-2.172a2.978 2.978 0 0 0 -2.121.879l-8.361 8.36a7.537 7.537 0 1 0 5.415 5.415l1.239-1.239v-2.415h3v-3h2.414l1.707-1.707a2.983 2.983 0 0 0 .879-2.122v-2.171a2 2 0 0 0 -2-2zm0 4.171a1 1 0 0 1 -.293.708l-1.121 1.121h-3.586v3h-3v3.585l-1.545 1.545a5.64 5.64 0 0 1 .545 2.37 5.5 5.5 0 1 1 -5.5-5.5 4.236 4.236 0 0 1 2.369.544l9.252-9.251a1.009 1.009 0 0 1 .707-.293h2.172zm-17 13.829a1 1 0 1 0 1-1 1 1 0 0 0 -1 1z"
              />
            </svg>
            <p>Upgrade Key</p>
          </div>

          <div
            @click="renewKey"
            class="bg-primary flex text-white items-center text-sm px-3 cursor-pointer gap-2 py-1 rounded-md m-2 mb-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m22 0h-2.172a2.978 2.978 0 0 0 -2.121.879l-8.361 8.36a7.537 7.537 0 1 0 5.415 5.415l1.239-1.239v-2.415h3v-3h2.414l1.707-1.707a2.983 2.983 0 0 0 .879-2.122v-2.171a2 2 0 0 0 -2-2zm0 4.171a1 1 0 0 1 -.293.708l-1.121 1.121h-3.586v3h-3v3.585l-1.545 1.545a5.64 5.64 0 0 1 .545 2.37 5.5 5.5 0 1 1 -5.5-5.5 4.236 4.236 0 0 1 2.369.544l9.252-9.251a1.009 1.009 0 0 1 .707-.293h2.172zm-17 13.829a1 1 0 1 0 1-1 1 1 0 0 0 -1 1z"
              />
            </svg>
            <p>Renew Key</p>
          </div>
        </div>
      </div>

      <div class="p-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ success_msg }}
          </div>
        </transition>

        <!-- <licence-tabs :updateLicenceList="updateLicenceList" v-if="searchInput"></licence-tabs> -->
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
          sort-order="asc"
        />

        <!-- <licence-tabs :updateLicenceList="updateLicenceList" v-if="!searchInput.length"></licence-tabs> -->
        <ve-table
          :columns="columns"
          :table-data="paginatedData"
          v-if="!searchInput.length"
          sort-order="asc"
        />

        <p v-if="tableData.length === 0" class="text-center py-3">
          No licences yet
        </p>

        <p
          v-if="searchInput.length && filteredTableData.length === 0"
          class="text-center py-3"
        >
          No results
        </p>
        <list-paginator
          :current-page="currentPage"
          :total-pages="totalPages"
          @page-changed="onPageChanged"
        >
        </list-paginator>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <licence-details
      :showLicenceDetails="showLicenceDetails"
      :licenceData="licenceData"
      @handleSuccess="handleSuccess"
      @close="close()"
    ></licence-details>
    <upgrade-licence-key
      :showUpgradeLicence="showUpgradeLicence"
      @handleSuccess="handleSuccess"
      :isSubmitted="isSubmitted"
      :organizations="organizations"
      :licences="licences"
      @close="close()"
    ></upgrade-licence-key>
    <renew-licence-key
      :showrenewLicence="showrenewLicence"
      @handleSuccess="handleSuccess"
      :isRenewalSubmited="isRenewalSubmited"
      :organizations="organizations"
      :licences="licences"
      @close="showrenewLicence = false"
      :reload="reload"
    ></renew-licence-key>
  </div>
</template>

<script>
import LicenceDetails from "./licenceDetails.vue";
import UpgradeLicenceKey from "./upgradeLicenceKey.vue";
import RenewLicenceKey from "./renewLicenceKey.vue";
import Loader from "../components/loader/loader.vue";
import LicenceTabs from "./licenceTabs.vue";
import ListPaginator from "../utils/listPaginator.vue";
//import sidebavmenu from "@/components/table/menu.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Licences",
  components: {
    LicenceDetails,
    Loader,
    UpgradeLicenceKey,
    LicenceTabs,
    ListPaginator,
    RenewLicenceKey,
  },
  data() {
    return {
      showLicenceDetails: false,
      showUpgradeLicence: false,
      showrenewLicence: false,
      loading: false,
      get_error: null,
      showSuccess: false,
      success_msg: null,
      licenceData: null,
      organizations: null,
      isSubmitted: false,
      isRenewalSubmited: false,
      licences: null,
      currentTab: "Active",
      searchInput: "",
      currentPage: 1,
      pageSize: 10,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Organization",
          key: "aa",
          title: "Organization",
          headerAlign: "left",
          align: "left",
          sortable: true,
        },
        { field: "Managers", key: "bb", title: "Managers" },
        { field: "Employees", key: "cc", title: "Employees" },
        { field: "LicenseTerm", key: "LicenseTerm", title: "License Term" },
        {
          field: "StartDate",
          key: "a",
          title: "Start Date",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => {
            const date = new Date(row.StartDate);
            const options = {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            };
            return date.toLocaleDateString("en-US", options);
          },
        },
        {
          field: "ExpiryDate",
          key: "b",
          title: "Expiry Date",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => {
            const date = new Date(row.ExpiryDate);
            const options = {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            };
            return date.toLocaleDateString("en-US", options);
          },
        },
        {
          field: "SubscriptionStatus",
          key: "c",
          title: "Status",
          renderBodyCell: ({ row }) => {
            return row?.Status.toLowerCase() === "expired" ? (
              <p class="text-green-900 bg-red-200 p-1 py-1  rounded-md  w-20 mx-auto">
                {row?.Status}
              </p>
            ) : (
              <p class="text-green-900 bg-green-200 p-1 py-1  rounded-md  w-20 mx-auto">
                {row?.Status}
              </p>
            );
          },
        },

        {
          field: "Review",
          key: "f",
          title: "Action",
          renderBodyCell: ({ row }) => {
            return (
              <div
                on-click={() => this.openReview(row)}
                class="bg-primary cursor-pointer text-white p-1 py-1  rounded-md  w-20 mx-auto font-medium text-sm"
              >
                View
              </div>
            );
          },
        },
      ],

      tableData: [
        {
          OrganizationName: "Dataposit Limited",
          Managers: 10,
          Employees: 50,
          StartDate: "03/01/2023",
          ExpiryDate: "03/08/2023",
          Status: "Active",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    totalPages() {
      return Math.ceil(this.tableData.length / this.pageSize);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.tableData.slice(startIndex, endIndex);
    },
  },
  created() {
    this.getOrganizations(this.currentTab);
    this.getLicences(this.currentTab);
  },
  methods: {
    reload() {
      this.getLicences();
    },

    onPageChanged(page) {
      this.currentPage = page;
    },
    close() {
      this.licenceData = null;
      this.showLicenceDetails = false;
      this.showUpgradeLicence = false;
    },
    openReview(row) {
      this.licenceData = row;
      this.showLicenceDetails = true;
      this.showUpgradeLicence = false;
    },
    handleSuccess(message) {
      this.licenceData = null;
      this.showLicenceDetails = false;
      this.showUpgradeLicence = false;
      this.success_msg = message;
      this.showSuccess = true;
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
      this.getOrganizations(this.currentTab);
      this.getLicences(this.currentTab);
    },
    async getOrganizations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `organization/${this.$ApiVersion}/request`,
          options
        );
        this.loading = false;
        this.organizations = response.data.Data;
        this.tableData = response.data.Data;
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },

    async getLicences(currentTab) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `licenses/${this.$ApiVersion}/request`,
          options
        );
        this.loading = false;
        this.licenses = response.data.Data;
        this.tableData = response.data.Data;

        if (currentTab.trim() === "Expired") {
          this.tableData = this.tableData.filter(
            (entry) => entry.Status === "Expired"
          );
        } else if (currentTab.trim() === "Active") {
          this.tableData = this.tableData.filter(
            (entry) => entry.Status === "Active"
          );
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },

    upgradeKey() {
      this.showUpgradeLicence = true;
    },
    renewKey() {
      this.showrenewLicence = true;
    },
    updateLicenceList(currentTab) {
      this.getLicences(currentTab);
    },
  },
};
</script>
